import { render, staticRenderFns } from "./AccountBlock.vue?vue&type=template&id=eb8cb018&"
import script from "./AccountBlock.vue?vue&type=script&lang=js&"
export * from "./AccountBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports